import "./ProductEditor.scss"
import React, { Component } from "react"
import numeral from "numeral"
import { observer } from "mobx-react"
import { addProductStore } from "../../stores"
import { Button, TextInput, Thumbnail } from "../../lib"
import ProductSubmit from "./ProductSubmit"

class ProductEditor extends Component {
  state = {
    submitted: false,
  }

  handleSubmit = e => {
    e.preventDefault()
    addProductStore
      .submitConfig()
      .then(() => this.setState({ submitted: true }))
  }

  render() {
    if (this.state.submitted) {
      return <ProductSubmit />
    }

    return (
      <div className="ProductEditor">
        <form onSubmit={this.handleSubmit}>
          <label>
            <h5>Product Name</h5>
            <p>This is what people will see on your store.</p>
            <TextInput
              required
              pattern="^.{3,50}$"
              placeholder="Enter a name"
              value={addProductStore.productName}
              onChange={addProductStore.changeName}
              title="Title should be between 3 and 50 characters long"
            />
          </label>
          <div>
            <label>
              <h5>Profit</h5>
              <p>How much would you like to make per order?</p>
              <TextInput
                required
                pattern="^\d+\.\d{2}$"
                title="Profit should be a valid currency format"
                value={addProductStore.sellerProfit}
                onChange={v => addProductStore.changeProfit(v)}
              />
            </label>
            <div className="ProductEditor_computed">
              <div className="ProductEditor_base">
                <h5>Production Cost</h5>
                <h2>{numeral(addProductStore.basePrice).format("$0.00")}</h2>
              </div>
              <div className="ProductEditor_selling">
                <h5>List Price</h5>
                <h2>
                  {numeral(
                    addProductStore.basePrice +
                      parseFloat(addProductStore.sellerProfit || 0)
                  ).format("$0.00")}
                </h2>
              </div>
            </div>
          </div>
          <Button styleName="submit" type="submit">
            Create your product
          </Button>
        </form>
        <ul className="ProductEditor_preview">
          {addProductStore.productFiles.map(file => (
            <li key={file.id}>
              <Thumbnail
                size={200}
                color={addProductStore.selectedColor}
                design={addProductStore.productDesigns[file.id]}
                mockup={addProductStore.productMockups[file.id]}
                mockupColor={addProductStore.selectedColor}
              />
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

ProductEditor.displayName = "ProductEditor"

export default observer(ProductEditor)



// WEBPACK FOOTER //
// ./src/products/add/ProductEditor.js